var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(" Copyright © "+_vm._s(_vm.currentYear)+" "),(_vm.isCnLocale())?_c('span',[_vm._v(" 六式格玛半导体 ")]):_c('span',[_vm._v(" 6 Sigma Semiconductor")])])])}
var staticRenderFns = []

export { render, staticRenderFns }